import Vue from 'vue';
import Vuelidate from 'vuelidate';
import { required, minValue } from 'vuelidate/lib/validators';
import datePicker from '../../../components/forms/component.date-picker.vue';
import ageSwitch from '../../../components/forms/component.age-birthdate-input-switch.vue';
import { MainVueOpts } from '../../../main-vue';
import GUPlanIds from '../../../helper-functions/companies/gu-planids';
import {
    isAfterField,
    monthDate,
    createDateByLangStr,
    onlyAlphaNumeric,
    convertDateByLang,
    createDateByLangApplications
} from '../../../helper-functions/helper-functions';
import {
    createUpdateApplicationService,
    changeInSessionStorage,
    checkExpiredAndTriggerValidation,
    goToFirstError
} from '../../../helper-functions/services';
import Step1Mixin from '../mixins/Step1Mixin';
import { guPlanIds } from './shared';

Vue.use(Vuelidate);

export default {
    mixins:[MainVueOpts, Step1Mixin],
    components:{
        'date-picker': datePicker,
        'age-switch': ageSwitch
    },
    props:['form-data'],
    data: function() {
        return {
            form: {
                homeCountryOption: this.formData.homeCountryOption || "",
                primaryAndSpouseArray:[{
                    age:null,
                    tripCost: null,
                    travelerType: 'primary'
                },
                {
                    age:null,
                    tripCost: null,
                    travelerType: 'spouse'
                }],
                childrenListArray: [{
                    age:null,
                    tripCost: null,
                    travelerType: 'child'
                }],
                LTNumberOfMonths: ibJS.application?.ltNumberOfMonths && parseInt(ibJS.application?.ltNumberOfMonths) > 2 ? ibJS.application.ltNumberOfMonths : ''
            },
            travelerLimit: 15,
            formSending: false,
            showMobileError:false,
            showStartDateError: false,
            startDateTodayError: false,
            showTravelerValidation: false,
            canAddMore: true,
            totalNumberOfTravelers : 0,
            showChildrenRequiredError: false,
            submitted: false,
            UserLoggedInMyAcoount: ibJS.UserLoggedInMyAcoount,
            hasChildfromQuote: false,
            hasSpousefromQuote: false,
            requireAdditional: false,
            requireChild: false,
            guPlanId: new GUPlanIds()
        }
    },
    validations: function(){
        var validations = {
            form:{
                startDate: {
                    required,
                    onlyAlphaNumeric,
                    monthDate
                },
                endDate: {
                    required,
                    onlyAlphaNumeric,
                    monthDate,
                    isAfterStartDate: isAfterField('startDate', false)
                },
                LTNumberOfMonths:{},
                primaryAndSpouseArray:{
                    $each:{
                        age:{
                           requiredOnlyPrimary,
                           requiredAdditional,
                           minValue: minValue(0),
                        }
                    }
                },
                childrenListArray: {
                    $each:{
                        age:{
                           requiredChild,
                           childAge,
                           minValue: minValue(0),
                        }
                    }
                }
            }
        };

        if(this.form.endDate=='' && this.form.planId != guPlanIds.Diplomat_LT_Including_US && this.form.planId != guPlanIds.Diplomat_LT_Excluding_US){
            this.showEndDateError=true;
        }else{
            this.showEndDateError=false;
        }
        if(window.ibJS.planId == guPlanIds.Diplomat_LT_Including_US || window.ibJS.planId == guPlanIds.Diplomat_LT_Excluding_US) {
            validations.form.LTNumberOfMonths.required = required;
            delete validations.form.endDate.required;
            delete validations.form.endDate.isAfterStartDate;
        }
        if(this.form.startDate!='' && this.form.endDate!=''){
            var startDate = createDateByLangStr(this.form.startDate,'en');
            var endDate = createDateByLangStr(this.form.endDate,'en');
        }

        function requiredOnlyPrimary(x,a){
            return a.travelerType === 'primary' && (x === '' || x === null) ? false : true;
        }

        function requiredAdditional(x,a) {
            if(this.requireAdditional &&  a.travelerType === 'spouse') {
                return (x === '' || x === null) ? false : true;
            } else {
                return true;
            }
        }

        function childAge(x){
            return x != null && x != undefined && x > 17 ? false : true;
        }

        const self = this;
        function requiredChild(x) {
            if(self.requireChild) {
                return self.form.childrenListArray.length && (x === '' || x === null) ? false : true;
            }
            return self.form.childrenListArray.length > 1 && (x === '' || x === null) ? false : true;    
        }


        // if(this.isFromQuoteResults) {
        //     validations.form.childrenListArray.$each.age.requiredChild = requiredChild;
        //     // validations.form.childrenListArray.$each.age.childAge = childAge;
        // }

        return validations;
    },
    created: function(){
        var self = this;

        if(self.isMobile) {
            this.form.primaryAndSpouseArray = [{
                age:null,
                tripCost: null,
                travelerType: 'primary'
            }];
            this.form.childrenListArray = [];
        }

        // when the user comes back to step 1 after going to step 2 or beyond

         if(self.application != null){
             this.retrieveExistingTravelers()
        } else {
            self.form.travelerInfos[0].travelerType = 'primary';
            self.form.travelerInfos.splice(2,1);
            if(self.form.travelerInfos[1]) self.form.travelerInfos[1].travelerType = 'spouse';
        }
        //reload arrays when returning to page
        self.form.travelerInfos.forEach((x,i)=>{
            if(x.travelerType === 'primary' || x.travelerType === ""){
                self.form.primaryAndSpouseArray.shift()
                self.form.primaryAndSpouseArray.unshift(x)
            }
            else if(x.travelerType === 'spouse'){
                if(!self.isMobile) self.form.primaryAndSpouseArray.pop()
                self.form.primaryAndSpouseArray.push(x)
            }
            else if(x.travelerType === 'child'){
                self.form.childrenListArray.push(x)
            }
        });

        if(self.form.childrenListArray.length > 1 && !self.isMobile){
            self.form.childrenListArray.splice(0,1);
        }
        if(self.form.childrenListArray.length > 8){
            self.form.childrenListArray.splice(8,self.form.childrenListArray.length);
        }

        checkExpiredAndTriggerValidation.call(this);

        $(document).ready(function () {
            $('.o-Form').on('click', function () {
                self.showTravelers = false;
            });

            $('.js-Stop-propagation').on('click', function (e) {
                e.stopPropagation();
            });
        });
    },
    computed: {
        showActionButtonError() {
            return this.$v.form.$error && this.$v.form.$invalid;
        }
    },
    watch:{
        'form.endDate': function() {
            this.createDate();
        },
        'form.startDate': function() {
            this.showStartDateError = false;
            this.startDateTodayError = false;
            this.createDate();
        },
        'form.LTNumberOfMonths': function() {
            if(ibJS.application) {
                this.form.endDate = '';
            }
        }
    },
    mounted: function(){
        // this.decideMaxLength();
        convertDateByLang(this.form,window.globalLanguage.lang);
    },
    methods: {
        createQuote: function (e) {
            /*Global Underwriter*/
            e.preventDefault();
            var error =false;

            this.$v.$touch();

            this.form.travelerInfos=[];
            var arrays = ['primaryAndSpouseArray', 'childrenListArray'];

            arrays.forEach((y)=>{
                this.form[y].forEach( x => {
                    if(x.age !== null){
                        this.form.travelerInfos.push(x)
                    }
                });
            });

            Vue.nextTick(() => goToFirstError('inValid') );

            var quoteResultsURL='/api/'+ibJS.productName+'/quote-results/?lang=en';
            if (!this.$v.$invalid && !error && !this.showEndDateError && this.form.travelerInfos.length < 11) {
                var _this = this;

                this.spliceTravelers();

                Vue.nextTick(() => {
                    let langBasedData = Object.assign({}, this.form);
                    changeInSessionStorage.call(this, "appFromQuoteResult", false);
                    createDateByLangApplications(langBasedData, window.globalLanguage.lang);
                    createUpdateApplicationService.call(this, quoteResultsURL, langBasedData, 'application');
                    this.submitted = true;
                });
                this.submitted = false;
            }else{
                this.showMobileError = true;
            }
        },
        retrieveExistingTravelers() {
            if(this.form.travelerInfos?.length) {
                this.form.travelerInfos = [];

                for(let i = 0; i < this.application.travelerInfos.length; i++) {
                   let currentTraveler = this.application.travelerInfos[i];
                   let newTraveler = {
                       age: currentTraveler.age,
                       tripCost: null,
                       quotePrice:null,
                       travelerType: currentTraveler.travelerType || 'primary'
                   };

                   this.form.travelerInfos.push(newTraveler);
               }

               if(this.isMobile && this.form.travelerInfos.length > 1) {
                    let spouseTravelers = this.form.travelerInfos.filter(traveler => traveler.travelerType === 'spouse');
                    if(spouseTravelers.length == 0) {
                        let newTraveler = {
                            age: null,
                            tripCost: null,
                            quotePrice:null,
                            travelerType: 'spouse'
                        };
                        this.form.travelerInfos.splice(1, 0, newTraveler);
                    }
                }

               if (ibJS.fromQuoteResults) {
                    this.detectRequiredFields();
                }
            }
            
           /** reset missing ages values */
           for (var i = 0; i < this.form.travelerInfos.length; i++){
               if(this.form.travelerInfos[i].age == -1){
                   this.form.travelerInfos[i].age = null;
                   this.showChildErrorText=true;
                   this.showTravelers=true;
               }
           }
        },
        /**
         * When coming from Quote results page, we require ages since some of them are not 
         * provided on the quote form. That doesn't apply when coming from step2 however.
         */
        detectRequiredFields() {
            let nonChildCount = 0;

            this.form.travelerInfos?.forEach(traveler => {
                if (traveler.travelerType === 'child') {
                    this.requireChild = true;
                } else {
                    nonChildCount++;
                    if (nonChildCount === 2) {
                        this.requireAdditional = true;
                    } 
                }
            })
        },
        createDate: function(){
            if(this.form.startDate!='' && this.form.endDate!=''){
                var startDate = createDateByLangStr(this.form.startDate,'en');
                var endDate = createDateByLangStr(this.form.endDate,'en');
            }
        },
        addChild: function(){
            let isChild = this.form.primaryAndSpouseArray.length >= 2;
            var numbOfChildrenList = this.form.childrenListArray.length;
            var newTraveler = {
                tripCost: null,
                age: null,
                travelerType: isChild ? 'child' : 'spouse'
            };
            if(numbOfChildrenList < 8){
                if(isChild) this.form.childrenListArray.push(newTraveler);
            }
            if(!isChild) {
                this.form.primaryAndSpouseArray.push(newTraveler);
            }
        },
        deleteSpouse() {
            this.form.primaryAndSpouseArray.splice(1, 1);
        },
        resetAgeValidation: function(index,type){
            if(!(/^\d+$/.test(this.form[type][index].age))){
                this.form[type][index].age=null;
            }
        },
        removeMobileError: function() {
            this.showMobileError = false;
        }
    }
};
